// import axios from 'axios'
// state
const state = {
  categoriesDisabledParks: true,
  kpisIntervalStationsParks: null,
  chartsIntervalStationsParks: null,
  kpisParks: null,
  stationChartParks: null,
  stationByIdChartParks: null,
  updateCompareStations: null
}

// getters
const getters = {
  getKpisIntervalStationsDataParks (state) {
    return state.kpisIntervalStationsParks
  },
  getCategoriesDisabledParks (state) {
    return state.categoriesDisabledParks
  },
  getChartsIntervalStationsDataParks (state) {
    return state.chartsIntervalStationsParks
  },
  getCategoriesStationsDataParks (state) {
    return state.gisDataByCategoriesParks
  },
  getKpisDataParks (state) {
    return state.kpisParks
  },
  getStationChartDataParks (state) {
    return state.stationChartParks
  },
  getStationByIdChartDataParks (state) {
    return state.stationByIdChartParks
  },
  getCompareStations (state) {
    return state.updateCompareStations
  }
}

// actions
const actions = {
  // Update interval Stations
  updateKpisIntervalStationsParks ({ commit, state }, data) {
    commit('UPDATE_KPIS_INTERVAL_STATIONS_PARKS', data)
  },
  // Update chart interval Stations
  updateChartsIntervalStationsParks ({ commit, state }, data) {
    commit('UPDATE_CHARTS_INTERVAL_STATIONS_PARKS', data)
  },
  // Update Categories Stations
  updateCategoryStationParks ({ commit, state }, data) {
    commit('UPDATE_CATEGORY_STATION_PARKS', data)
  },
  // Update Categories Stations
  updateCategoriesStationsParks ({ commit, state }, data) {
    commit('UPDATE_CATEGORIES_STATIONS_PARKS', data)
  },
  // Update Categories Disabled
  updateCategoryDisabledParks ({ commit, state }, data) {
    commit('UPDATE_CATEGORY_DISABLED_PARKS', data)
  },
  // Update data Kpis Viewer Parks
  updateKpisViewerParks ({ commit, state }, data) {
    const store = this
    state.kpisInterval = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/kpis/' + data.product + '/interval',
      data: null,
      params: {
        product: data.product,
        typeProduct: data.typeProduct,
        type: data.type,
        interval: data.interval,
        intervalUnit: data.intervalUnit,
        city: 'ES LPA'
      },
      mutation: 'UPDATE_KPIS_PARKS'
    }
    store.dispatch('callService', dataService)
  },
  // Update indicators data Stations meteo chart
  updateStationChartDataParks ({ commit, state }, data) {
    const store = this
    state.kpisInterval = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/indicators/stations/chart/' + data.chartType + '/chartData',
      data: null,
      params: {
        chartType: data.chartType,
        intervalUnit: data.intervalUnit,
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA'
      },
      mutation: 'UPDATE_STATION_CHART_DATA_PARKS'
    }
    store.dispatch('callService', dataService)
  },
  // Update indicators data Station by Id meteo chart
  updateStationByIdChartDataParks ({ commit, state }, data) {
    const store = this
    state.kpisInterval = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/indicators/stations/' + data.stationId + '/charts/' + data.chartType + '/chartData',
      data: null,
      params: {
        chartType: data.chartType,
        timeInterval: data.timeInterval,
        stationId: data.stationId,
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA'
      },
      mutation: 'UPDATE_STATIONBYID_CHART_DATA_PARKS'
    }
    store.dispatch('callService', dataService)
  },
  updateCompareStations ({ commit, state }, data) {
    const store = this
    state.kpisInterval = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/comparative/' + data.id,
      data: null,
      params: {
        type: data.type,
        from1: data.from1,
        to1: data.to1,
        from2: data.from2,
        to2: data.to2,
        id: data.id,
        city: 'ES LPA'
      },
      mutation: 'UPDATE_COMPARE_STATIONS'
    }
    store.dispatch('callService', dataService)
  }
}

// mutations
const mutations = {
  UPDATE_KPIS_INTERVAL_STATIONS_PARKS (state, data) {
    state.kpisIntervalStationsParks = data
  },
  UPDATE_CHARTS_INTERVAL_STATIONS_PARKS (state, data) {
    state.chartsIntervalStationsParks = data
  },
  UPDATE_CATEGORIES_STATIONS_PARKS (state, data) {
    state.gisDataByCategoriesParks = data
  },
  UPDATE_CATEGORY_DISABLED_PARKS (state, data) {
    state.categoriesDisabledParks = data
  },
  UPDATE_KPIS_PARKS (state, data) {
    state.kpisParks = data
  },
  UPDATE_STATION_CHART_DATA_PARKS (state, data) {
    state.stationChartParks = data
  },
  UPDATE_STATIONBYID_CHART_DATA_PARKS (state, data) {
    state.stationByIdChartParks = data
  },
  UPDATE_CATEGORY_STATION_PARKS (state, data) {
    state.gisDataByCategoriesParks[data.index] = data.info
  },
  UPDATE_COMPARE_STATIONS (state, data) {
    state.updateCompareStations = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardParksAndGardens.js